import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  public getTokenHeader() {
    let accessToken = JSON.parse(localStorage.getItem('user') as string)[
      'data'
    ]['tokens']['access_token'];
    let _header: HttpHeaders = new HttpHeaders({
      Authorization: accessToken,
    });
    return _header;
  }
}
